import React, { memo, useEffect, useState  } from "react";
import "./hw5.css";
// import Item from "./Item";
import Hw5Grid from "../Hw5Grid";

// const Canvas2List = memo(({ users, handleDelete }) => {
const Hw5List = memo(({ animaciones }) => {
  const [animationNameL1, setAnimationNameL1] = useState("ils1-----");

  return (
    <ul className="hw5Grid-container">
       {animaciones.map((animacion) => (
        <Hw5Grid key={animacion.id} id={animacion.id} name={animacion.name} animurl={animacion.animurl} composition2={animacion.composition} />
       ))
       }

    </ul>
  );
});
// }

export default Hw5List;
